var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-update-rate",class:{'increased': _vm.isIncreased, 'decreased': !_vm.isIncreased},attrs:{"title":_vm.title}},_vm._l((_vm.value),function(monthValue,index){return _c('div',{key:index,staticClass:"ui-update-rate_month",style:({'height': _vm.getMonthHeight(monthValue)})})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }